import { _ } from './constants';
export function coalesce(current, fallback) {
    return current === _ ? fallback : current;
}
